//Utils
import { splitter } from '../utils/splitter';
export const useFiguresSplitHook = (figure) => {
    return splitter(figure);
};
//# sourceMappingURL=figures-split.hook.js.map